import React from 'react';
import { AspectRatio, Box, Flex, Image } from '@chakra-ui/react';

export const MainGame = ({ recommendedGameImage }: { recommendedGameImage: string }) => {
	return (
		<Flex
			w="100%"
			flexDirection="column"
			gridGap="0px"
		>
			<AspectRatio
				ratio={3 / 4}
				width="100px"
			>
				{!recommendedGameImage ? (
					<Box
						w="100px"
						bgColor="#2D2D2D"
					>
						{' '}
						Your image{' '}
					</Box>
				) : (
					<Image src={recommendedGameImage} />
				)}
			</AspectRatio>
			<Box
				bgColor="#FF3F3F"
				w="20px"
				h="2px"
			/>
		</Flex>
	);
};

export default MainGame;
